// Constants for different requests for current reducer
export default {
  siteInfo: 'SITE_INFO',
  reminders: 'REMINDERS',
};
